export default function StripeRefresh() {
  const restartOnboarding = async () => {
    try {
      const response = await fetch('/api/stripe/restart-onboarding');
      const data = await response.json();

      if (data.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <section className="mb-3">
      <div className="container">
        <div className="row d-flex align-items-center my-5">
          <div className="col-11 col-lg-6 mx-auto text-center">
            <div className="card shadow border-0 p-5">
              <div className="mb-4">
                <i
                  className="bi bi-exclamation-triangle-fill text-warning"
                  style={{ fontSize: '70px' }}
                ></i>
              </div>

              <h2 className="mb-3">Informations manquantes</h2>

              <p className="text-muted">
                Votre compte Stripe n'est pas encore complètement configuré.
                <br />
                Vous devez finaliser certaines informations pour pouvoir recevoir des paiements.
              </p>

              <div className="alert alert-warning mt-3">
                Cliquez ci-dessous pour reprendre la configuration.
              </div>

              <button onClick={restartOnboarding} className="btn btn-warning btn-lg mt-3">
                Continuer la configuration
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
